import React, {createContext, useCallback, useContext, useMemo, useState} from 'react';

const LotteryTokenContext = createContext();

export const useLotteryToken = () => {
    const context = useContext(LotteryTokenContext);
    if (!context) {
        throw new Error('useLotteryToken must be used within LotteryTokenProvider');
    }
    return context;
};

const LotteryTokenProvider = ({children}) => {
    const [token, setToken] = useState(() => localStorage.getItem('lotteryToken'));
    const [role, setRole] = useState(() => localStorage.getItem('lotteryRole'));

    const login = useCallback((newToken, userRole) => {
        setToken(newToken);
        setRole(userRole);
        localStorage.setItem('lotteryToken', newToken);
        localStorage.setItem('lotteryRole', userRole);
    }, []);

    const logout = useCallback(() => {
        setToken(null);
        setRole(null);
        localStorage.removeItem('lotteryToken');
        localStorage.removeItem('lotteryRole');
    }, []);

    // Stable identities matter here: consumers memoize their data layer on
    // `logout`, and a fresh function each render would re-trigger their fetches.
    const value = useMemo(() => ({
        token,
        role,
        login,
        logout,
        isAuthenticated: !!token,
        isAdmin: role === 'admin',
        isUser: role === 'user'
    }), [token, role, login, logout]);

    return (
        <LotteryTokenContext.Provider value={value}>
            {children}
        </LotteryTokenContext.Provider>
    );
};

export default LotteryTokenProvider;
